import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../models/utilities/document-request";
import { API_METHODS } from "../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../utils/app-constants";

export class InventoryBookDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(id : string, name: string) {
        this.url = ApiEndpoints.INVENTORY_BOOK.formattify(id);
        this.filename = `inventory-book-${name}`;
    }

}
